import { render } from "./PageNumber10.vue?vue&type=template&id=446e31c4&scoped=true"
import script from "./PageNumber10.vue?vue&type=script&lang=js"
export * from "./PageNumber10.vue?vue&type=script&lang=js"

import "./PageNumber10.vue?vue&type=style&index=0&id=446e31c4&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446e31c4"]])

export default __exports__